import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import type { ExclusiveEventHintOrCaptureContext } from "@/services/logging/capture-client-exception";
import { captureClientException } from "@/services/logging/capture-client-exception";
export const useCaptureException = (exception, hint) => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== exception || $[1] !== hint) {
    t0 = () => {
      captureClientException(exception, hint);
    };
    t1 = [exception, hint];
    $[0] = exception;
    $[1] = hint;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};